/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(11);
__webpack_require__(12);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(15);
__webpack_require__(16);
__webpack_require__(17);

__webpack_require__(18);
__webpack_require__(19);

var dialog = __webpack_require__(20);

var QBDown = __webpack_require__(23);
var myGifts = __webpack_require__(24);
var showPrize = __webpack_require__(25);
var shareGetChance = __webpack_require__(26);
var notSub = __webpack_require__(27);
var activtyEnd = __webpack_require__(28);
var userContact = __webpack_require__(29);

var answerEnd = __webpack_require__(30);
var answerNum = __webpack_require__(31);
var littleFollow = __webpack_require__(32);

var userInfoObj = JSON.parse(sessionStorage.getItem("userInfo"));
var errorCode = __webpack_require__(33);

function mask(type, title, msg, headsrc, width, height) {
  if (type === "QBrowser") {
    console.trace();
    dialog({
      width: 500,
      height: 290,
      className: 'activtyEnd',
      body: QBDown({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {},
      onshow: function onshow() {
        if (msg == '请前往电脑参与') {
          $('.pcqb-QBDown-btn').hide();
        }
      }
    }).show();
  } else if (type === "myGifts") {
    dialog({
      width: 820,
      height: 428,
      body: myGifts({}),
      className: 'mygifts',
      onclose: function onclose() {},
      onshow: function onshow() {
        setTimeout(function () {
          $("#qtips").mouseover(function () {
            $(this).css("overflow", "visible");
          });
          $(".duiRule").mouseout(function () {
            $("#qtips").css("overflow", "hidden");
          });
          $(".duiRuleQr").mouseout(function () {
            $("#qtips").css("overflow", "hidden");
          });
        }, 400);
      }
    }).show();
  } else if (type === "showPrize") {
    dialog({
      width: 550,
      height: 590,
      body: showPrize({})
    }).show();
  } else if (type === "shareGetChance") {
    dialog({
      width: 550,
      height: 280,
      className: 'activtyEnd',
      body: shareGetChance({}),
      onclose: function onclose() {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      },
      onshow: function onshow() {}
    }).show();
  } else if (type === "notSub") {
    dialog({
      width: 550,
      height: 280,
      body: notSub({}),
      onclose: function onclose() {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      }
    }).show();
  } else if (type === "activtyEnd") {
    dialog({
      width: 550,
      height: 280,
      className: 'activtyEnd',
      body: activtyEnd({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {
        if (msg == "为选手投票可额外获得1次抽奖机会哦！") {
          console.log("scroll to anchor!!!!!!!!!!");
          $("html,body").animate({
            scrollTop: 830
          }, 200);
        }
      }
    }).show();
  } else if (type === "userCon") {
    dialog({
      width: 550,
      height: 485,
      body: userContact({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {

        var userInfo = {
          "userName": $("#userName").val(),
          "phoneNum": $("#phoneNum").val(),
          "provinceId_m": $("#provinceId_m").val(),
          "cityId_m": $("#cityId_m").val(),
          "areaId_m": $("#areaId_m").val(),
          "detailAddr": $("#detailAddr").val(),
          "zipCode": $("#zipCode").val()
        };
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      },
      onshow: function onshow() {
        if (!window.userInfoObj) {
          //非空校验
          return;
        }
        setTimeout(function () {
          $("#userName").val(userInfoObj["userName"]);
          $("#phoneNum").val(userInfoObj["phoneNum"]);
          $("#provinceId_m").val(userInfoObj["provinceId_m"]);
          $("#cityId_m").val(userInfoObj["cityId_m"]);
          $("#areaId_m").val(userInfoObj["areaId_m"]);
          $("#detailAddr").val(userInfoObj["detailAddr"]);
          $("#zipCode").val(userInfoObj["zipCode"]);
        }, 500);
      }
    }).show();
  } else if (type === "answerEnd") {
    dialog({
      width: 550,
      height: 280,
      body: answerEnd({
        title: title,
        msg: msg
      })
    }).show();
  } else if (type === "answerNum") {
    dialog({
      width: 550,
      height: 380,
      body: answerNum({
        headsrc: headsrc,
        title: title,
        msg: msg
      })
    }).show();
  } else if (type === "errorCode") {
    dialog({
      width: 550,
      height: 280,
      body: errorCode({
        title: title,
        msg: msg
      }),
      onshow: function onshow() {},
      onclose: function onclose() {}
    }).show();
  } else if (type === "littleFollow") {
    dialog({
      width: 550,
      height: 280,
      body: littleFollow({
        title: title,
        msg: msg
      }),
      onshow: function onshow() {
        if (msg === '对不起，你已经抽过奖了') {
          lottery.oneClick = true;
        } else if (msg === '关注满3个主播才可以抽奖喔') {
          lottery.onlyClick = true;
        } else if (msg === '参与活动才有抽奖机会哟~') {
          lottery.onlyClick = true;
        }
      },
      onclose: function onclose() {
        if (msg == '你还有抽奖机会待领取') {
          $("html,body").animate({ scrollTop: 830 }, 200);
        }
      }
    }).show();
  }
}

module.exports = mask;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var guid = void 0;
var mask = __webpack_require__(0);

function request() {}
//发送请求
request.send = function (obj, cb) {
  if (!guid) {
    try {
      guid = qbsdk.getGuid(); //window.external.getGuid().split("-").join("")
    } catch (e) {}
  }
  if (qbsdk.isQB() /*api.isQB*/) {
      zUtil.ensureLogin(function () {
        obj.guid = guid;
        zHttp.send(obj, function (res) {
          if (res.ret == 10002) {
            qq.login.open();
          } else if (res.ret == 10004) {
            //todo
          } else {
            cb && cb(res);
          }
        });
      });
    }
  // else {
  //   mask("QBrowser")
  // }
};

module.exports = request;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(3);
var utils = __webpack_require__(42);
var request = __webpack_require__(1);
__webpack_require__(43);
var mask = __webpack_require__(0);

_qblog.setting({ key: 20007, tcss: true });
_qblog.wsd.click("TRANSLATESYNCSPREAD.PV");

//AMS新集成
//zHttp.baseUrl = "//iyouxi3.vip.qq.com/ams3.0.php";
//活动地址 不带任何参数
var _pageUrl = location.protocol + '//' + location.host + location.pathname;
//main
/*let Page = qv.zero.extend(qv.zero.AbstractPage, {
  // 项目ID
  userJsonID: 290247,
  loadExtHandler: true,
  init: function () {
    Page.superclass.init.apply(this, arguments);

  },
  initEvent: function () {
    Page.superclass.initEvent.apply(this, arguments);
    $('body').on('click', 'a[href="#"]', function (e) {
      e.preventDefault();
    });
    qq.login.bind('login', function () {

    });
    qq.login.bind('logout', function () {

    });
    if (qq.login.getUin()) {

    }else{

    }

  },

})
window.page = new Page()*/

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = {
  'title': '腾讯翻译君 - 同声传译',
  'keywords': '翻译,在线翻译,腾讯翻译君,翻译在线,英文翻译,英语翻译,日语翻译,韩语翻译,fanyi',
  'description': '翻译君是腾讯最新出品的实时会话翻译软件，支持中、英、日、韩等多门语言。具有精准语言识别，高效、免费等特点。非常适用于境外旅游、对外交流、口语练习等情境，让你体验同声传译般的流畅和快感。'
};

config.layout = __webpack_require__(4);

__webpack_require__(6);

config.qbtop = [__webpack_require__(7)];

config.qbheader = [];

config.qbbody = [__webpack_require__(9), __webpack_require__(34), __webpack_require__(36), __webpack_require__(38)];

config.qbfooter = [__webpack_require__(40)];

module.exports = config;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(5);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

var arr = ["TRANS_LOGO", "TRANS_ONLINE", "PRODUCT_INTRO", "SYNC_SEND", "TRANS_SERV"];

$(document).on('click', 'a[data-id]', function (e) {

  var vid = $(this).attr('data-id');
  _qblog.wsd.click('TRANSLATESYNCSPREAD.' + arr[vid - 1]);
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(10);
var request = __webpack_require__(1);
var mask = __webpack_require__(0);

var Tween = {

  linear: function linear(t, b, c, d) {
    //匀速
    return c * t / d + b;
  },
  easeIn: function easeIn(t, b, c, d) {
    //加速曲线
    return c * (t /= d) * t + b;
  },
  easeOut: function easeOut(t, b, c, d) {
    //减速曲线
    return -c * (t /= d) * (t - 2) + b;
  },
  easeBoth: function easeBoth(t, b, c, d) {
    //加速减速曲线
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t + b;
    }
    return -c / 2 * (--t * (t - 2) - 1) + b;
  },
  easeInStrong: function easeInStrong(t, b, c, d) {
    //加加速曲线
    return c * (t /= d) * t * t * t + b;
  },
  easeOutStrong: function easeOutStrong(t, b, c, d) {
    //减减速曲线
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  },
  easeBothStrong: function easeBothStrong(t, b, c, d) {
    //加加速减减速曲线
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t * t * t + b;
    }
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
  },
  elasticIn: function elasticIn(t, b, c, d, a, p) {
    //正弦衰减曲线（弹动渐入）
    if (t === 0) {
      return b;
    }
    if ((t /= d) == 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    if (!a || a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else {
      var s = p / (2 * Math.PI) * Math.asin(c / a);
    }
    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
  },
  elasticOut: function elasticOut(t, b, c, d, a, p) {
    //正弦增强曲线（弹动渐出）
    if (t === 0) {
      return b;
    }
    if ((t /= d) == 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    if (!a || a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else {
      var s = p / (2 * Math.PI) * Math.asin(c / a);
    }
    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
  },
  elasticBoth: function elasticBoth(t, b, c, d, a, p) {
    if (t === 0) {
      return b;
    }
    if ((t /= d / 2) == 2) {
      return b + c;
    }
    if (!p) {
      p = d * (0.3 * 1.5);
    }
    if (!a || a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else {
      var s = p / (2 * Math.PI) * Math.asin(c / a);
    }
    if (t < 1) {
      return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    }
    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
  },
  backIn: function backIn(t, b, c, d, s) {
    //回退加速（回退渐入）
    if (typeof s == 'undefined') {
      s = 1.70158;
    }
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  },
  backOut: function backOut(t, b, c, d, s) {
    if (typeof s == 'undefined') {
      s = 3.70158; //回缩的距离
    }
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  },
  backBoth: function backBoth(t, b, c, d, s) {
    if (typeof s == 'undefined') {
      s = 1.70158;
    }
    if ((t /= d / 2) < 1) {
      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    }
    return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
  },
  bounceIn: function bounceIn(t, b, c, d) {
    //弹球减振（弹球渐出）
    return c - Tween['bounceOut'](d - t, 0, c, d) + b;
  },
  bounceOut: function bounceOut(t, b, c, d) {
    if ((t /= d) < 1 / 2.75) {
      return c * (7.5625 * t * t) + b;
    } else if (t < 2 / 2.75) {
      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
    } else if (t < 2.5 / 2.75) {
      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
    }
    return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
  },
  bounceBoth: function bounceBoth(t, b, c, d) {
    if (t < d / 2) {
      return Tween['bounceIn'](t * 2, 0, c, d) * 0.5 + b;
    }
    return Tween['bounceOut'](t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
  }
};

function getStyle(obj, attr) {
  //浏览器兼容
  if (obj.currentStyle) {
    //obj.currentStyle.width;
    return parseInt(obj.currentStyle[attr]);
  } else {
    return parseInt(getComputedStyle(obj, false)[attr]);
  }
}

function startMove(obj, json, alltime, animation, fn) {
  if (obj.timer) {
    clearInterval(obj.timer);
  }
  var startObj = {};
  var moveObj = {};

  for (var attr in json) {

    startObj[attr] = parseInt(getStyle(obj, attr)) || 0;
    moveObj[attr] = json[attr] - startObj[attr];
  }

  var startTime = new Date().getTime();

  obj.timer = setInterval(function () {

    var changeTime = new Date().getTime();
    var t = Math.min(changeTime - startTime, alltime);

    if (t == alltime) {
      clearInterval(obj.timer);
      if (fn) {
        fn();
      }
    }

    for (var attr in json) {
      //obj.style[attr] = objC[attr] * t/d + objB[attr] + 'px';
      var value = Tween[animation](t, startObj[attr], moveObj[attr], alltime);
      if (attr == 'opacity') {
        obj.style.opacity = value;
        obj.style.filter = 'alpha(opacity=' + value * 100 + ')';
      } else {
        obj.style[attr] = value + 'px';
      }
    }
  }, 10);
}

$(function () {
  var i = 0;
  // setInterval(function () {
  //   if(i%2){
  //     $("#ba2").addClass('fadein');
  //     $("#ba1").addClass('fadeout');
  //     $("#ba2").removeClass('fadeout');
  //     $("#ba1").removeClass('fadein');
  //   }else{
  //     $("#ba1").addClass('fadein');
  //     $("#ba2").addClass('fadeout');
  //     $("#ba1").removeClass('fadeout');
  //     $("#ba2").removeClass('fadein');
  //   }
  //   i++;
  // },4000)
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var csss = __webpack_require__(21);
var template = __webpack_require__(22);
module.exports = Dialog;

var default_options = {
  body: '',
  width: 380,
  height: 0,
  className: 'cus',
  maskclose: true,
  onclose: null,
  onshow: null
};

var $body = $(document.body);
function disabledMouseWheel() {
  function scrollFunc(evt) {
    return false;
  }
  if (document.addEventListener) {
    document.addEventListener('DOMMouseScroll', scrollFunc, false);
  } //W3C
  window.onmousewheel = document.onmousewheel = scrollFunc; //IE/Opera/Chrome
}
function ableMouseWheel() {
  function scrollFuncRecover(evt) {
    return true;
  }
  if (document.addEventListener) {
    document.addEventListener('DOMMouseScroll', scrollFuncRecover, false);
  } //W3C
  window.onmousewheel = document.onmousewheel = scrollFuncRecover; //IE/Opera/Chrome
}
function Dialog(opts) {
  if (!(this instanceof Dialog)) return new Dialog(opts);
  this.opts = $.extend({}, default_options, opts);
  this._createElement();
  this._initEvents();
}

Dialog.prototype = {

  show: function show() {
    var self = this,
        opts = self.opts,
        $el = self.$el,
        $box = self.$box;
    $box.css({
      'width': opts.width,
      'margin-left': -opts.width / 2
    });
    $el.show();

    var h = opts.height > 0 ? opts.height : $box.height();
    self.$box.css({
      'height': h,
      'top': -h / 2,
      'margin-top': -h / 2
    });
    disabledMouseWheel();
    setTimeout(function () {
      self.$el.addClass('active');
      self.$el.addClass(opts.className);
    }, 0);
    opts.onshow && opts.onshow();
    return self;
  },

  close: function close() {
    ableMouseWheel();
    var self = this,
        opts = self.opts;
    self.$el.removeClass('active');
    self.$box.hide();
    setTimeout(function () {
      self.$el.hide();
      setTimeout(function () {
        self._destroy();
      }, 500);
    }, 350);
    opts.onclose && opts.onclose();
    return self;
  },

  on: function on() {
    var self = this,
        $el = self.$el;
    $el.on.apply($el, Array.prototype.slice.call(arguments));
    return self;
  },

  find: function find(selector) {
    return this.$box.find(selector);
  },

  _destroy: function _destroy() {
    this.$el.remove();
    this.$el = null;
    this.$box = null;
  },

  _initEvents: function _initEvents() {
    var self = this;
    self.opts.maskclose && self.$el.on('click', 'div.pcqb-dialog-mask', function (e) {
      self.close();
    });
    self.$el.on('click', '.submit', function (e) {
      self.close();
      self.opts.onclose && self.opts.onclose();
    });
    self.$el.on('click', '.close', function (e) {
      self.close();
    });
    self.$el.on('click', '.addres', function (e) {
      self.close();
      self.opts.onclose && self.opts.onclose();
      lottery.getUserContact(); //todo 耦合性太高
    });
  },

  _createElement: function _createElement() {
    var $el = $(template({
      body: this.opts.body
    }));
    this.$el = $el;
    this.$box = $el.find('div.dialog-wrap');
    $body.append($el);
  }

};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-container"><div class="dialog-mask"></div><div class="dialog-wrap"><span class="close">✕</span><div class="dialog-body"> ' +
((__t = (body)) == null ? '' : __t) +
' </div></div></div>';

}
return __p
}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-qb-down"><div class="qb-down prize"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a class="downQb" id="downloadQBBtn" href="https://dldir1.qq.com/invc/tt/QQBrowser_Setup_QB10.exe" onclick="_qblog.wsd.click(\'EMPRESS.QBDOWN.CLICK\');"></a></div></div></div>';

}
return __p
}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-myGifts"><div class="giftRecord prize"><div class="tit">获奖记录</div><div class="gifts"></div></div></div>';

}
return __p
}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-show-prize"><div class="gifts"></div></div>';

}
return __p
}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-share-getChance"><div class="notShare sma"><p>抽奖机会已用完，分享到以下任意渠道，</p><p>额外获得1次抽奖机会，追剧成功后即可生效！</p><div class="logo">分享至： <span class="QZ" onclick="lottery.shareTo(\'qzone\');"></span> <span class="WB" onclick="lottery.shareTo(\'sina\')"></span> <span class="QQ" onclick="lottery.shareTo(\'qq\')"></span></div></div></div>';

}
return __p
}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="notSub sma"><p>请订阅后再参与抽奖，据说手气更旺！</p><div class="btn"><a href="javascript:void(0)" onclick="lottery.sub(true);" class="close closeSub">订阅并抽奖</a></div></div></div>';

}
return __p
}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="outtime sma"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-user-contact"><div id="userCon"><div class="tit">填写联系方式</div><div class="userInfo"></div><div class="sub submit" onclick="lottery.setUserContact()">确认提交</div><div class="contact-hint"><span>提交后如需修改地址，请在本活动页面【获奖记录】中操作</span></div></div><div id="success-submit">提交成功</div></div>';

}
return __p
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-end"><div class="answer-end"><p class="body">需要把4个题答完再交卷哦~</p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-first"><div class="answer-first"><div class="answer-title"><img src="' +
((__t = (headsrc)) == null ? '' : __t) +
'"> <span class="title"> ' +
((__t = (title)) == null ? '' : __t) +
' </span></div><p class="body"> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a class="goWatch close" id="goWatch" href="https://v.qq.com/x/cover/vxz0cpf5fawnghw/u0026nf7g8r.html?ptag=qqbrowser&ADTAG=zd-activity" target="_blank">立即去看剧</a></div></div></div>';

}
return __p
}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common dialog-common-littlemask"><div class="hd"> ' +
((__t = (title)) == null ? '' : __t) +
' </div><div class="mask-little-tit-msg"> ' +
((__t = (msg)) == null ? '' : __t) +
' </div><div class="little-flow-btn ft"><button class="close" style="font-size:18px">我知道了</button></div></div>';

}
return __p
}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common dialog-common-littlemask"><div class="hd"> ' +
((__t = (title)) == null ? '' : __t) +
' </div><div class="mask-little-tit-msg"> ' +
((__t = (msg)) == null ? '' : __t) +
' </div><div class="little-flow-btn ft"><button class="toFankui" style="font-size:18px" onclick="lottery.toFankui();">我要反馈</button></div></div>';

}
return __p
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(35);
var request = __webpack_require__(1);
var mask = __webpack_require__(0);

$(function () {//初始化 老虎机


});

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(37);

// var arr = ["PICTURE_ONE","PICTURE_TWO","PICTURE_THREE","PICTURE_FOUR"]

// $(document).on('click', 'a[data-sid]', function (e) {

//   var vid = $(this).attr('data-sid');
//   _qblog.wsd.click('TRANSLATESYNCSPREAD.' + arr[vid-1]);
// });

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(39);
var request = __webpack_require__(1);
var mask = __webpack_require__(0);

$(function () {
  //初始化 老虎机

  window.hintMail = function () {
    return;
    mask('littleFollow', '', '请确保安装了outlook或其他EMail软件');
  };
});

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(41);

var arr = ["QQ_BROWSER", "QQ_MAIL", "WECHAT", "TENCENT_QQ", "TENCENT_UNIVERSITY", "KING_HONOR"];

$(document).on('click', 'a[data-fid]', function (e) {

  var vid = $(this).attr('data-fid');
  _qblog.wsd.click('TRANSLATESYNCSPREAD.' + arr[vid - 1]);
});

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = utils;

function utils() {}

var parseUrlParams = utils.parseUrlParams = function (str) {
  str || (str = '');
  var vars = str.split("&");
  var json = {},
      pair;

  for (var i = 0; i < vars.length; i++) {
    pair = pair.split('=');
    json[pair[0]] = decodeURIComponent(pair[1] || '');
  }
  return json;
};
var getUrlParams = utils.getUrlParams = function (key) {
  var query = window.location.search.substring(1);
  var json = parseUrlParams(query);
  utils.getUrlParams = function (k) {
    return k ? json[k] : json;
  };
  return key ? json[key] : json;
};

utils.animateScrollTo = function (cval, tval, callback) {
  var f = 30,
      dval = tval - cval;

  function __run() {
    dval = dval / 2;
    if (Math.abs(dval) > 1) {
      cval += dval;
      callback(Math.round(cval));
      setTimeout(__run, f);
    } else {
      callback(tval);
    }
  }
  __run();
};
//QQ浏览器判断
utils.isQQBrowser = function () {
  return !/Trident/i.test(navigator.userAgent) && /QQBrowser/i.test(navigator.userAgent) && window.external && window.external.getVersion ? true : false;
};
/**
 * 对日期进行格式化，
 * @param date 要格式化的日期
 * @param format 进行格式化的模式字符串
 *     支持的模式字母有：
 *     y:年,
 *     M:年中的月份(1-12),
 *     d:月份中的天(1-31),
 *     h:小时(0-23),
 *     m:分(0-59),
 *     s:秒(0-59),
 *     S:毫秒(0-999),
 *     q:季度(1-4)
 * @return String
 */
utils.dateFormat = function (date, format) {
  date = new Date(date);

  var map = {
    "M": date.getMonth() + 1, //月份
    "d": date.getDate(), //日
    "h": date.getHours(), //小时
    "m": date.getMinutes(), //分
    "s": date.getSeconds(), //秒
    "q": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
    var v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });
  return format;
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 来自 http://stdl.qq.com/stdl/tq_center/activity/common/header_footer_v2.js
// 暂时使用，后面需要替换掉这个旧的

(function ($) {
  var userInfo = {};
  var isQB = isQB = isQQBrowser();

  function getUserInfo(cb) {
    zUtil.ensureLogin(function () {
      $.ajax({
        url: 'http://cgi.vip.qq.com/contact/getusercontact',
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function success(json) {
          if (json.ret === 0) {
            userInfo = {
              name: json.data.NAME,
              phone: json.data.PHONE,
              email: json.data.EMAIL,
              address: json.data.POST_ADDR
            };
            cb ? cb(userInfo) : null;
          } else if (json.ret === -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  };

  function setUserInfo(obj, cb) {
    for (var i in obj) {
      obj[i] = obj[i].trim();
    }
    if (obj.name.length == 0) {
      alert('濮撳悕涓嶈兘涓虹┖锛�');
      return;
    } else if (obj.name.length < 2 || !/^[a-zA-Z\u4e00-\u9fa5]{0,}$/.test(obj.name)) {
      alert('濮撳悕涓嶅悎娉曪紝璇烽噸鏂拌緭鍏ワ紒');
      return;
    }
    if (obj.phone.length == 0) {
      alert('鎵嬫満鍙蜂笉鑳戒负绌猴紒');
      return;
    } else if (obj.phone != userInfo.phone) {
      if (isNaN(obj.phone) || obj.phone.length != 11) {
        alert('璇疯緭鍏ユ湁鏁堢殑鎵嬫満鍙凤紒');
        return;
      }
    }
    if (obj.email.length == 0) {
      alert('鐢靛瓙閭涓嶈兘涓虹┖锛�');
      return;
    } else if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(obj.email)) {
      alert('璇疯緭鍏ユ湁鏁堢殑鐢靛瓙閭锛�');
      return;
    }
    if (obj.address.length == 0) {
      alert('閭瘎鍦板潃涓嶈兘涓虹┖锛�');
      return;
    } else if (!/^[a-zA-Z0-9\u4e00-\u9fa5]{0,}$/.test(obj.address)) {
      alert('闈炴硶鐨勬眽瀛楀拰鑻辨枃瀛楃锛岃閲嶆柊杈撳叆锛�');
      return;
    }
    var _url = 'http://cgi.vip.qq.com/contact/setusercontact?name=' + obj.name + '&phone=' + obj.phone + '&email=' + obj.email + '&post_address=' + obj.address + '&noChange_phone=';
    if (obj.phone == userInfo.phone) {
      _url += "1";
    } else {
      _url += "0";
    }
    var temp = 0;
    for (var k in obj) {
      if (obj[k] == userInfo[k]) {
        temp++;
      }
    }
    if (temp == 4) {
      cb ? cb() : null;
      return;
    }
    zUtil.ensureLogin(function () {
      $.ajax({
        url: _url,
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function success(json) {
          if (json.ret == 0) {
            cb ? cb() : null;
          } else if (json.ret == -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  }

  function initUserInfo(phone) {
    $('body').on('focus', '#' + phone, function () {
      if ($(this).val() == userInfo.phone) {
        $(this).val('');
      }
    });
    $('body').on('blur', '#' + phone, function () {
      if ($(this).val() == '') {
        $(this).val(userInfo.phone);
      }
    });
  }

  function submitUserInfo(name, phone, email, address, cb) {
    userContact = {
      name: $('#' + name).val(),
      phone: $('#' + phone).val(),
      email: $('#' + email).val(),
      address: $('#' + address).val()
    };
    setUserInfo(userContact, function () {
      cb ? cb() : '';
    });
  }

  function report(hottagValue) {
    window.setTimeout(function () {
      try {
        pgvSendClick({
          hottag: hottagValue
        });
      } catch (e) {}
    }, 100);
  }

  function dataReport(a, b, c, d, e, f, g, h, i) {
    window.setTimeout(function () {
      try {
        window.external.dataReport(a, b, c, d, e, f, g, h, i);
      } catch (e) {
        console.log(e);
      }
    }, 100);
  }
  window.setTimeout(function () {
    if (typeof pgvMain == 'function') {
      pgvMain("pathtrace", {
        pathStart: true,
        tagParamName: "ADTAG",
        useRefUrl: true,
        override: true,
        careSameDomainRef: false
      });
    }
  }, 1000);

  function getQBVersion() {
    var version = 0;
    try {
      try {
        version = window.external.getVersion() || 1;
      } catch (e) {
        version = window.external.getbrowserversion() || 1;
      }
    } catch (e) {
      version = /QQBrowser/.test(navigator.userAgent) || "100.0.0.0";
    }
    return version;
  }

  function isQQBrowser() {
    var version = getQBVersion();
    var result = version != "100.0.0.0" && version != 0;
    isQQBrowser = function isQQBrowser() {
      return result;
    };
    return result;
  }

  window.api = {
    setUserInfo: setUserInfo,
    getUserInfo: getUserInfo,
    initUserInfo: initUserInfo,
    submitUserInfo: submitUserInfo,
    report: report,
    dataReport: dataReport,
    getQBVersion: getQBVersion,
    isQQBrowser: isQQBrowser,
    isQB: isQB
  };
})(jQuery);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js